import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import {TablerModalCloseButton as ModalCloseButton} from './TablerCloseButtons';

const ModalFrame = ({
  isOpen,
  onClose,
  title,
  children,
  footer = null,
  showCloseButton = true,
  overlayProps = {},
  contentProps = {},
  bodyProps = {},
  footerProps = {},
  ...modalProps
}: Record<string, any>) => (
  <Modal isOpen={isOpen} onClose={onClose} {...modalProps}>
    <ModalOverlay {...overlayProps} />
    {/* Default side gutter keeps fixed-size dialogs from running edge-to-edge
        on phones; callers can override via contentProps. */}
    <ModalContent mx={4} {...contentProps}>
      {title ? <ModalHeader fontWeight="normal">{title}</ModalHeader> : null}
      {showCloseButton ? <ModalCloseButton /> : null}
      <ModalBody {...bodyProps}>{children}</ModalBody>
      {footer ? <ModalFooter {...footerProps}>{footer}</ModalFooter> : null}
    </ModalContent>
  </Modal>
);

export default ModalFrame;
